import React, { useContext, useEffect, useState } from 'react';
import { shuffle } from 'lodash';
import { SaleItemsContext } from '../';
import LatestItemGroup from '../components/latest-item-group';
/**
 * アイテムマップからリストに変換して返す
 * @param latestItemListMap
 * @returns
 */
const getLatestItemList = (latestItemListMap) => {
    const latestItemList = [];
    for (const key of Object.keys(latestItemListMap)) {
        for (const latestItem of latestItemListMap[key]) {
            latestItemList.push(latestItem);
        }
    }
    return latestItemList;
};
const LatestInfo = () => {
    const [saleItemsState] = useContext(SaleItemsContext);
    const [latestItemList, setLatestItemList] = useState([]);
    useEffect(() => {
        if (saleItemsState && saleItemsState.latestItems) {
            // 最新製品リストをシャッフルしてセット
            setLatestItemList(shuffle(getLatestItemList(saleItemsState.latestItems)));
        }
    }, [
        saleItemsState
    ]);
    return (React.createElement(React.Fragment, null,
        latestItemList.length === 0 && null,
        latestItemList.length > 0 && (React.createElement("div", { className: "latest-info", id: "js-latest-info" },
            React.createElement("div", { className: "latest-info-body" },
                React.createElement("div", { className: "latest-info-lead text-center md:gutter" },
                    "\u305D\u306E\u4ED6\u30B9\u30AF\u30A6\u30A7\u30A2\u30FB\u30A8\u30CB\u30C3\u30AF\u30B9\u306E",
                    React.createElement("br", { className: "md:hidden" }),
                    "\u65B0\u4F5C\u60C5\u5831\u3082\u304A\u898B\u9003\u3057\u306A\u304F\uFF01"),
                React.createElement("div", { className: "latest-info-notes text-center gutter" }, "\u203B\u4EE5\u4E0B\u65B0\u4F5C\u30BF\u30A4\u30C8\u30EB\u306F\u30BB\u30FC\u30EB\u5BFE\u8C61\u5916\u3067\u3059\u3002"),
                React.createElement(LatestItemGroup, { latestItemList: latestItemList }))))));
};
export default LatestInfo;
